export type ProgramPartnerId =
  | 'khazanah'
  | 'pokoi'
  | 'google'
  | 'mohe'
  | 'ive'
  | 'mosti'
  | 'mof'
  | 'yayasan-peneraju'

export type ProgramPartner = {
  id: ProgramPartnerId
  title: string
}

export const programPartners: ProgramPartner[] = [
  {
    id: 'khazanah',
    title: 'Khazanah'
  },
  {
    id: 'yayasan-peneraju',
    title: 'Yayasan Peneraju'
  },
  {
    id: 'pokoi',
    title: 'Pok Oi Group (Hong Kong)'
  },
  {
    id: 'google',
    title: 'Google'
  },
  {
    id: 'mohe',
    title: 'Ministry of Higher Education (Malaysia)'
  },
  {
    id: 'ive',
    title: 'Hong Kong Institute of Vocational Education'
  },
  {
    id: 'mosti',
    title: 'Ministry of Science, Technology and Innovation (Malaysia)'
  },
  {
    id: 'mof',
    title: 'Ministry of Finance (Malaysia)'
  }
]
